export default __webpack_public_path__ + "static/media/ambassador-bg.405f3635.webp";